import { gql } from '../../__generated__/gql'

export const ADD_TO_CART_MUTATION = gql(`
  mutation addToCart($itemId: Int!) {
    addToCart(input: { itemId: $itemId }) {
      clientMutationId
    }
  }
`)
